import Base from './base'
import { Deal } from '../types/deal'

export type GetDealsOptions = {
  ids?: string[]
  related_contact_ids?: string[]
  names?: string[]
  'names[_contains]'?: string
}

export default class Deals extends Base {
  async get(options?: GetDealsOptions): Promise<Deal[]> {
    const response = await this.api.get('deals', { params: { ...options } })
    return response?.data ?? []
  }
}
